import { Button, Card, Typography } from "antd";
import Logo from "assets/images/logo.svg";

import React from "react";
import LogoBackground from "assets/images/diary-bg-img.jpg";
export default function PersonalityTest() {
  const { Title, Paragraph } = Typography;

  return (
    <React.Fragment>
      <div className="login-container d-flex">
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>
        <Card bordered={false} className="login-card sub-info-card">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <h3 className="sub-info-heading">
            Have you ever taken Myers-Briggs Type Indicator(MBTI) personality
            test before?
          </h3>
          <div className="sub-info-btn">
            <Button block size="large" type="ghost">
              No, I haven't taken
            </Button>
            <Button block size="large" type="primary">
              Yes, I have taken
            </Button>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
